
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const MetauxNonFerreuxTypes = () => {
  return (
    <div className="bg-gray-50 p-8 rounded-lg mb-12">
      <h2 className="text-2xl font-bold text-fabre-gray mb-6">
        Types de Métaux Non Ferreux que nous Recyclons
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Aluminium</h3>
          <p className="text-sm text-gray-600 mb-2">Profilés, tôles, canettes, radiateurs, déchets d'usinage</p>
          <Link 
            to="/nos-services/achat-metaux/aluminium" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur l'aluminium
          </Link>
        </div>
        
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Cuivre</h3>
          <p className="text-sm text-gray-600 mb-2">Câbles électriques, tuyauteries, circuits électroniques</p>
          <Link 
            to="/nos-services/achat-metaux/cuivre" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur le cuivre
          </Link>
        </div>
        
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Plomb</h3>
          <p className="text-sm text-gray-600 mb-2">Batteries, tuyaux, plaques, poids, contrepoids</p>
          <Link 
            to="/nos-services/achat-metaux/plomb" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur le plomb
          </Link>
        </div>
        
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Zinc</h3>
          <p className="text-sm text-gray-600 mb-2">Gouttières, toitures, pièces galvanisées, alliages</p>
          <Link 
            to="/nos-services/achat-metaux/zinc" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur le zinc
          </Link>
        </div>
        
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Laiton</h3>
          <p className="text-sm text-gray-600 mb-2">Robinetterie, décorations, instruments de musique</p>
          <Link 
            to="/nos-services/achat-metaux/laiton" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur le laiton
          </Link>
        </div>
        
        <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-fabre-darkgreen mb-3">Inox</h3>
          <p className="text-sm text-gray-600 mb-2">Éviers, équipements industriels, chutes de fabrication</p>
          <Link 
            to="/nos-services/achat-metaux/inox" 
            className="text-xs text-fabre-green hover:underline"
          >
            En savoir plus sur l'inox
          </Link>
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <Button asChild variant="outline" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen">
          <Link to="/nos-services/achat-metaux">
            Voir tous nos services d'achat de métaux
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default MetauxNonFerreuxTypes;
